import { createSlice } from "@reduxjs/toolkit";
import { analyticsApi } from "../../middleware/analyticsApi";

const initialState = {
  analyticData: {},
  falseAlarmanalyticsData: [],
};

export const analyticsSlice = createSlice({
  name: "analytics",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      analyticsApi.endpoints.getSystemOverallAnalytics.matchFulfilled,
      (state, { payload }) => {
        state.analyticData = payload;
      }
    );
    builder.addMatcher(
      analyticsApi.endpoints.getMessageSummariesPerSession.matchFulfilled,
      (state, { payload }) => {
        state.falseAlarmanalyticsData = payload;
      }
    );
  },
});

export const analyticsActions = analyticsSlice.actions;
export const analyticsReducer = analyticsSlice.reducer;
